import {Component} from '@angular/core';

@Component({
  selector: 'app-link-schedule',
  templateUrl: './link-schedule.component.html',
  styleUrls: ['./link-schedule.component.scss']
})
export class LinkScheduleComponent {
}
